import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { BookOpen, Users } from 'lucide-react';
export function AtAGlance() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-12 sm:py-16 md:py-20 px-5 sm:px-6 bg-gradient-to-b from-black via-stone-950 to-black" data-id="element-138" data-mp="3nhmadhka3r09">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 50
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto" data-id="element-139" data-mp="k3rzkj95tojb">
        {/* Symbolic Treasure Chest Opening Animation */}
        <div className="mb-8 sm:mb-12" data-id="element-140" data-mp="a75cdntd2le4">
          <svg viewBox="0 0 300 200" className="w-32 sm:w-48 mx-auto" style={{
          filter: 'drop-shadow(0 0 20px rgba(217, 119, 6, 0.4))'
        }} data-id="element-141" data-mp="648rfqgcmd70">
            {/* Chest base */}
            <rect x="75" y="120" width="150" height="60" fill="#78716c" stroke="#f59e0b" strokeWidth="2" data-id="element-142" data-mp="2qt6l7ml2zjno" />

            {/* Chest lock */}
            <circle cx="150" cy="150" r="8" fill="#fbbf24" data-id="element-143" data-mp="2i3a2sz2zkm7g" />

            {/* Chest lid (animated opening) */}
            <motion.g initial={{
            rotateX: 0
          }} animate={inView ? {
            rotateX: -60
          } : {}} transition={{
            duration: 1.5,
            delay: 0.5,
            ease: 'easeOut'
          }} style={{
            transformOrigin: '150px 120px'
          }} data-id="element-144" data-mp="2n1258n19bqpw">
              <path d="M 75 120 Q 75 80, 150 70 Q 225 80, 225 120 L 225 120 L 75 120 Z" fill="#57534e" stroke="#f59e0b" strokeWidth="2" data-id="element-145" data-mp="1zaxzoa4idgw9" />
              {/* Lid lock part */}
              <rect x="145" y="115" width="10" height="15" fill="#fbbf24" data-id="element-146" data-mp="1pfe7nyt2f2cs" />
            </motion.g>

            {/* Glowing treasures emerging */}
            {[...Array(5)].map((_, i) => <motion.circle key={i} cx={130 + i * 10} cy="100" r="3" fill="#fbbf24" initial={{
            y: 0,
            opacity: 0
          }} animate={inView ? {
            y: [-20, -40, -60],
            opacity: [0, 1, 0]
          } : {}} transition={{
            duration: 2,
            delay: 1 + i * 0.2,
            repeat: Infinity,
            repeatDelay: 2
          }} data-id="element-147" data-mp="1gcvb1wfvhlyz" data-mpi={i} />)}

            {/* Light rays from chest */}
            {[...Array(3)].map((_, i) => {
            const angle = -60 + i * 30;
            const x1 = 150;
            const y1 = 120;
            const x2 = 150 + Math.sin(angle * Math.PI / 180) * 60;
            const y2 = 120 - Math.cos(angle * Math.PI / 180) * 60;
            return <motion.line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#fbbf24" strokeWidth="2" opacity="0.6" initial={{
              pathLength: 0,
              opacity: 0
            }} animate={inView ? {
              pathLength: 1,
              opacity: [0, 0.6, 0]
            } : {}} transition={{
              duration: 1.5,
              delay: 1.2 + i * 0.1,
              repeat: Infinity,
              repeatDelay: 2
            }} data-id="element-148" data-mp="4x3rmf2v9sfb" data-mpi={i} />;
          })}
          </svg>
        </div>
      </motion.div>
    </section>;
}